var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1521_4076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1521_4076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9993 18.3332C8.95213 18.3332 7.2181 17.6228 5.79727 16.2019C4.37643 14.7811 3.66602 13.0471 3.66602 10.9998C3.66602 8.95262 4.37643 7.21859 5.79727 5.79775C7.2181 4.37692 8.95213 3.6665 10.9993 3.6665C12.0535 3.6665 13.0618 3.88421 14.0243 4.31963C14.9868 4.75505 15.8118 5.37762 16.4993 6.18734V3.6665H18.3327V10.0832H11.916V8.24984H15.766C15.2771 7.39428 14.6087 6.72206 13.7608 6.23317C12.9129 5.74428 11.9924 5.49984 10.9993 5.49984C9.47157 5.49984 8.17296 6.03456 7.10352 7.104C6.03407 8.17345 5.49935 9.47206 5.49935 10.9998C5.49935 12.5276 6.03407 13.8262 7.10352 14.8957C8.17296 15.9651 9.47157 16.4998 10.9993 16.4998C12.1757 16.4998 13.2375 16.1637 14.1848 15.4915C15.132 14.8193 15.7966 13.9332 16.1785 12.8332H18.1035C17.6757 14.4526 16.8049 15.7741 15.491 16.7978C14.1771 17.8214 12.6799 18.3332 10.9993 18.3332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.2f19e3352bbf1ee02ba6db66606827bd.svg";
export { ForwardRef as ReactComponent };